import { Paper, Table, TableContainer, TableHead, TableCell, TableBody, TableRow, Typography } from "@mui/material";

export default function Carts({data}){

    const find = (n,c) => {
        const item = data.find(i => i.cart === n && i.category === c);
        return parseFloat(item?.users || 0).toLocaleString();
    }

    return <>

        <Typography variant='h3'>Nb de clients avec X formations payantes</Typography>

        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell>Dentaire</TableCell>
                        <TableCell>Kiné</TableCell>
                        <TableCell>Médecine</TableCell>
                        <TableCell>Pharma</TableCell>
                        <TableCell>Santé Mentale</TableCell>
                        <TableCell>Infirmier</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>1 formation</TableCell>
                        <TableCell>{find('1','dentaire')}</TableCell>
                        <TableCell>{find('1','kine')}</TableCell>
                        <TableCell>{find('1','medecine')}</TableCell>
                        <TableCell>{find('1','pharma')}</TableCell>
                        <TableCell>{find('1','sante-mentale')}</TableCell>
                        <TableCell>{find('1','infirmiere')}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>2 formations</TableCell>
                        <TableCell>{find('2','dentaire')}</TableCell>
                        <TableCell>{find('2','kine')}</TableCell>
                        <TableCell>{find('2','medecine')}</TableCell>
                        <TableCell>{find('2','pharma')}</TableCell>
                        <TableCell>{find('2','sante-mentale')}</TableCell>
                        <TableCell>{find('2','infirmiere')}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>3 formations ou +</TableCell>
                        <TableCell>{find('3+','dentaire')}</TableCell>
                        <TableCell>{find('3+','kine')}</TableCell>
                        <TableCell>{find('3+','medecine')}</TableCell>
                        <TableCell>{find('3+','pharma')}</TableCell>
                        <TableCell>{find('3+','sante-mentale')}</TableCell>
                        <TableCell>{find('3+','infirmiere')}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>

    </>

}